import React, {useContext} from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { screensConfig } from "../../screens/screensConfiguration";
import TabsNavigation from "./TabsNavigation";
import {getTranslation} from "../../helpers/getTranslation";
import UserContext from "../../helpers/UserContext";

const FullScreensStack = createStackNavigator();

export default function FullScreensNavigation() {

  const {userData, updateUserData} = useContext(UserContext)

  return (
    <FullScreensStack.Navigator>
      <FullScreensStack.Screen
        key={`TabsNavContainer`}
        name={`TabNavigationScreensContainer`}
        component={TabsNavigation}
        options={{headerShown: false}}
      />
      {screensConfig.filter((screen) => (screen.noTabs && screen?.countries[userData.baseSiteUID])).map((screen, idx) => (
        <FullScreensStack.Screen
          key={`HomeScreen_${idx}`}
          name={screen.navSlug}
          component={screen.component}
          initialParams={{
            screenTitle: screen.screenTitle,
            headerOptions: {...screen.headerOptions, menuArea: 'back'},
            showCopyright: screen.showCopyright,
            noTabs: true
          }}
          options={{
            headerShown:false,
            title: getTranslation(screen.navTitle),
          }}
        />
      ))}
    </FullScreensStack.Navigator>
  )
}
